import Tabs from './tabs-container';
import Pane from './pane/pane-container';

export {
	Tabs,
	Pane
}


// WEBPACK FOOTER //
// ./src/component/tabs/index.js